import { Stats } from "react-instantsearch";
import styles from "./SearchStats.module.scss";
import { PropsWithChildren } from "react";

type SearchStatsProps = {
  singular?: string;
  plural?: string;
};
const SearchStats: React.FC<PropsWithChildren<SearchStatsProps>> = ({
  singular,
  plural
}) => {
  return (
    <Stats
      classNames={{ root: styles.container }}
      translations={{
        rootElementText({ nbHits }) {
          return nbHits > 1
            ? `${nbHits.toLocaleString()} ${plural}`
            : `${nbHits.toLocaleString()} ${singular}`;
        }
      }}
    />
  );
};
export default SearchStats;
